<mat-slide-toggle (change)="changeTheme()" #darkModeSwitch [checked]="checked">
</mat-slide-toggle>